"use strict";

var _slicedToArray = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _chunk4L4HBCDZjs = require('./chunk-4L4HBCDZ.js'); // src/hooks/model.ts


var COOKIE_SESSION_EXPIRES_AT = "sessionExpiresAt";
var DEFAULT_MODAL_LISTENER = {
  logoutOccurred: function logoutOccurred() {
    var isLoggingEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (isLoggingEnabled) {
      _chunk4L4HBCDZjs.info.call(void 0, {
        isLoggingEnabled: isLoggingEnabled,
        message: "logout event occurred"
      });
    }
  },
  modalCancelClicked: function modalCancelClicked() {
    var isLoggingEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (isLoggingEnabled) {
      _chunk4L4HBCDZjs.info.call(void 0, {
        isLoggingEnabled: isLoggingEnabled,
        message: "modalCancel event occurred"
      });
    }
  },
  modalLoginClicked: function modalLoginClicked() {
    var isLoggingEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (isLoggingEnabled) {
      _chunk4L4HBCDZjs.info.call(void 0, {
        isLoggingEnabled: isLoggingEnabled,
        message: "modalLogin event occurred"
      });
    }
  },
  modalShown: function modalShown() {
    var isLoggingEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (isLoggingEnabled) {
      _chunk4L4HBCDZjs.info.call(void 0, {
        isLoggingEnabled: isLoggingEnabled,
        message: "modalShown event occurred"
      });
    }
  }
}; // src/hooks/useBidderSessionExpiresSoon.ts

var _datefns = require('date-fns');

var _react = require('react');

var _universalcookie = require('universal-cookie');

var _universalcookie2 = _interopRequireDefault(_universalcookie);

var useBidderSessionExpiresSoon = function useBidderSessionExpiresSoon(_ref) {
  var _ref$customLogoutUser = _ref.customLogoutUser,
      customLogoutUser = _ref$customLogoutUser === void 0 ? logoutUser : _ref$customLogoutUser,
      getIsUserLoggedIn = _ref.getIsUserLoggedIn,
      isFeatureEnabled = _ref.isFeatureEnabled,
      _ref$isLoggingEnabled = _ref.isLoggingEnabled,
      isLoggingEnabled = _ref$isLoggingEnabled === void 0 ? false : _ref$isLoggingEnabled,
      _ref$modalListener = _ref.modalListener,
      modalListener = _ref$modalListener === void 0 ? DEFAULT_MODAL_LISTENER : _ref$modalListener,
      _ref$sessionExpiratio = _ref.sessionExpirationCheckInSeconds,
      sessionExpirationCheckInSeconds = _ref$sessionExpiratio === void 0 ? 5 : _ref$sessionExpiratio;

  var _react$useState$call = _react.useState.call(void 0, false),
      _react$useState$call2 = _slicedToArray(_react$useState$call, 2),
      alertShown = _react$useState$call2[0],
      setAlertShown = _react$useState$call2[1];

  var _react$useState$call3 = _react.useState.call(void 0, false),
      _react$useState$call4 = _slicedToArray(_react$useState$call3, 2),
      userCanceledWarning = _react$useState$call4[0],
      setUserCanceledWarning = _react$useState$call4[1];

  var _react$useState$call5 = _react.useState.call(void 0, false),
      _react$useState$call6 = _slicedToArray(_react$useState$call5, 2),
      loginButtonClicked = _react$useState$call6[0],
      setLoginButtonClicked = _react$useState$call6[1];

  var _react$useState$call7 = _react.useState.call(void 0, false),
      _react$useState$call8 = _slicedToArray(_react$useState$call7, 2),
      modalLogoutCalled = _react$useState$call8[0],
      setModalLogoutCalled = _react$useState$call8[1];

  var logoutOccurred = _react.useCallback.call(void 0, function () {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "Did we already call modalListener logout?"
    });

    if (!modalLogoutCalled) {
      _chunk4L4HBCDZjs.info.call(void 0, {
        isLoggingEnabled: isLoggingEnabled,
        message: "We have not called modal listener logout so we are calling it now."
      });

      setModalLogoutCalled(true);
      modalListener.logoutOccurred(isLoggingEnabled);
    } else {
      _chunk4L4HBCDZjs.info.call(void 0, {
        isLoggingEnabled: isLoggingEnabled,
        message: "since we already called the modalListener logout, we are not going to call it again"
      });
    }
  }, [isLoggingEnabled, modalListener, modalLogoutCalled]);

  var manageDialog = _react.useCallback.call(void 0, function () {
    return manageTheDialog({
      alertShown: alertShown,
      customLogoutUser: customLogoutUser,
      getIsUserLoggedIn: getIsUserLoggedIn,
      isFeatureEnabled: isFeatureEnabled,
      isLoggingEnabled: isLoggingEnabled,
      logoutOccurred: logoutOccurred,
      modalListener: modalListener,
      setAlertShown: setAlertShown,
      userCanceledWarning: userCanceledWarning
    });
  }, [alertShown, customLogoutUser, getIsUserLoggedIn, isFeatureEnabled, isLoggingEnabled, logoutOccurred, modalListener, userCanceledWarning]);

  var handleClose = function handleClose() {
    modalListener.modalCancelClicked(isLoggingEnabled);
    setAlertShown(false);
    setUserCanceledWarning(true);
  };

  _react.useEffect.call(void 0, function () {
    var intervalId;

    if (isFeatureEnabled) {
      _chunk4L4HBCDZjs.info.call(void 0, {
        isLoggingEnabled: isLoggingEnabled,
        message: "will start the interval"
      });

      intervalId = setInterval(function () {
        manageDialog();
      }, sessionExpirationCheckInSeconds * 1e3);
    }

    return function () {
      if (isFeatureEnabled) {
        _chunk4L4HBCDZjs.info.call(void 0, {
          isLoggingEnabled: isLoggingEnabled,
          message: "Shutting down the interval"
        });

        clearInterval(intervalId);
      }
    };
  }, [manageDialog, isFeatureEnabled, isLoggingEnabled, sessionExpirationCheckInSeconds]);

  var handleLoginButtonClicked = _react.useCallback.call(void 0, function () {
    modalListener.modalLoginClicked(isLoggingEnabled);
    setLoginButtonClicked(true);
    destroyTheSession({
      customLogoutUser: customLogoutUser,
      getIsUserLoggedIn: getIsUserLoggedIn,
      isFeatureEnabled: isFeatureEnabled,
      isLoggingEnabled: isLoggingEnabled,
      logoutOccurred: logoutOccurred
    });
  }, [getIsUserLoggedIn, isFeatureEnabled, isLoggingEnabled, customLogoutUser, logoutOccurred, modalListener]);

  if (!isFeatureEnabled) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[useBidderSessionExpiresSoon] Feature flag is disabled: ".concat(isFeatureEnabled)
    });

    return {
      alertShown: false,
      handleClose: handleClose,
      handleLoginButtonClicked: function handleLoginButtonClicked() {},
      loginButtonClicked: loginButtonClicked,
      message: "feature flag is disabled",
      modalMessage: "",
      modalTitle: ""
    };
  }

  if (!getIsUserLoggedIn()) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "User is not logged in: ".concat(getIsUserLoggedIn())
    });

    return {
      alertShown: false,
      handleClose: handleClose,
      handleLoginButtonClicked: function handleLoginButtonClicked() {},
      loginButtonClicked: loginButtonClicked,
      message: "user is not logged in",
      modalMessage: "",
      modalTitle: ""
    };
  }

  return {
    alertShown: alertShown,
    handleClose: handleClose,
    handleLoginButtonClicked: handleLoginButtonClicked,
    loginButtonClicked: loginButtonClicked,
    message: "Well, would you look at that.  It worked. Beta-6",
    modalMessage: "Your session will be ending in less than 10 minutes. Please login again.",
    modalTitle: "Session Status"
  };
};

var destroyTheSession = function destroyTheSession(_ref2) {
  var customLogoutUser = _ref2.customLogoutUser,
      getIsUserLoggedIn = _ref2.getIsUserLoggedIn,
      isFeatureEnabled = _ref2.isFeatureEnabled,
      isLoggingEnabled = _ref2.isLoggingEnabled,
      logoutOccurred = _ref2.logoutOccurred,
      _ref2$sendToLoginPage = _ref2.sendToLoginPage,
      sendToLoginPage = _ref2$sendToLoginPage === void 0 ? true : _ref2$sendToLoginPage;
  var cookies = new (0, _universalcookie2.default)();
  cookies.remove(COOKIE_SESSION_EXPIRES_AT);

  if (!getIsUserLoggedIn()) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[destroySession] user is not logged in."
    });

    return;
  }

  if (!isFeatureEnabled) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[destroySession] Feature Flag is disabled, will not attempt to destroy session"
    });

    return;
  }

  if (!isSessionWithinWarningTimeframe(isLoggingEnabled)) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[destroySession] Session Expiration is not within warning timeframe, will not attempt to destroy session"
    });

    return;
  }

  var guid = cookies.get("guid");

  if (!guid) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[destroySession] Guid is not defined"
    });
  } else {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[destroySession] Guid IS DEFINED"
    });

    logoutOccurred();
    customLogoutUser(sendToLoginPage);
  }
};

var logoutUser = function logoutUser() {
  var sendToLoginPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var returnUrl = window.location.href;

  if (sendToLoginPage) {
    returnUrl = "/asp/LoginBidder.asp?d=".concat(window.location.href);
  }

  var encodedReturnUrl = encodeURIComponent("".concat(returnUrl));
  setTimeout(function () {
    window.location.assign("/account/signout?returnUrl=".concat(encodedReturnUrl));
  }, 3e3);
};

var manageTheDialog = function manageTheDialog(_ref3) {
  var alertShown = _ref3.alertShown,
      customLogoutUser = _ref3.customLogoutUser,
      getIsUserLoggedIn = _ref3.getIsUserLoggedIn,
      isFeatureEnabled = _ref3.isFeatureEnabled,
      isLoggingEnabled = _ref3.isLoggingEnabled,
      logoutOccurred = _ref3.logoutOccurred,
      modalListener = _ref3.modalListener,
      setAlertShown = _ref3.setAlertShown,
      userCanceledWarning = _ref3.userCanceledWarning;

  if (!getIsUserLoggedIn()) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[manageDialog] user is not logged in"
    });

    return;
  }

  if (isSessionExpired(isLoggingEnabled)) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[manageDialog] session is expired, destroying session"
    });

    destroyTheSession({
      customLogoutUser: customLogoutUser,
      getIsUserLoggedIn: getIsUserLoggedIn,
      isFeatureEnabled: isFeatureEnabled,
      isLoggingEnabled: isLoggingEnabled,
      logoutOccurred: logoutOccurred,
      sendToLoginPage: false
    });
    return;
  }

  if (userCanceledWarning) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[manageDialog] user canceled warning, so we will not show it."
    });

    return;
  }

  if (alertShown && isSessionRefreshed(isLoggingEnabled)) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[manageDialog] setting alert shown to false.  AlertShown: ".concat(alertShown, ", IsSessionRefreshed: ").concat(isSessionRefreshed(isLoggingEnabled))
    });

    setAlertShown(false);
  } else if (!alertShown && isSessionWithinWarningTimeframe(isLoggingEnabled)) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[manageDialog] setting alert shown to false.  AlertShown: ".concat(alertShown, ", IsSessionWithinWarningTimeFrame: ").concat(isSessionWithinWarningTimeframe(isLoggingEnabled))
    });

    setAlertShown(true);
    modalListener.modalShown(isLoggingEnabled);
  }
};

var isSessionRefreshed = function isSessionRefreshed() {
  var isLoggingEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return !isSessionWithinWarningTimeframe(isLoggingEnabled);
};

var getSessionExpiresAtDate = function getSessionExpiresAtDate() {
  var isLoggingEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var cookies = new (0, _universalcookie2.default)();
  var sessionExpiresAt = cookies.get(COOKIE_SESSION_EXPIRES_AT);
  var sessionExpiresAtDate = sessionExpiresAt ? new Date(Number(sessionExpiresAt)) : null;

  _chunk4L4HBCDZjs.info.call(void 0, {
    isLoggingEnabled: isLoggingEnabled,
    message: "[getSessionExpiresAtDate] SessionExpiresAt: ".concat(sessionExpiresAt, " which is ").concat(sessionExpiresAtDate)
  });

  return sessionExpiresAtDate;
};

var isSessionExpired = function isSessionExpired() {
  var isLoggingEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var sessionExpiresAtDate = getSessionExpiresAtDate(isLoggingEnabled);

  if (!sessionExpiresAtDate) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[isSessionExpired] sessionExpiresAt is not defined: ".concat(sessionExpiresAtDate)
    });

    return false;
  }

  return sessionExpiresAtDate < /* @__PURE__ */new Date();
};

var isSessionWithinWarningTimeframe = function isSessionWithinWarningTimeframe() {
  var isLoggingEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var sessionExpiresAtDate = getSessionExpiresAtDate(isLoggingEnabled);

  if (!sessionExpiresAtDate) {
    _chunk4L4HBCDZjs.info.call(void 0, {
      isLoggingEnabled: isLoggingEnabled,
      message: "[isSessionWithinWarningTimeframe] sessionExpiresAt is not defined: ".concat(sessionExpiresAtDate)
    });

    return false;
  }

  var minuteDifference = Math.abs(_datefns.differenceInMinutes.call(void 0, sessionExpiresAtDate, /* @__PURE__ */new Date()));

  _chunk4L4HBCDZjs.info.call(void 0, {
    isLoggingEnabled: isLoggingEnabled,
    message: "[isSessionWithingWarningTimeframe] minuteDifference: ".concat(minuteDifference)
  });

  return minuteDifference <= 10;
};

exports.useBidderSessionExpiresSoon = useBidderSessionExpiresSoon;